import type { FC } from 'react';
import type { TrackerCategory } from '../../../../common/tracking/trackerService';
import {
  CommonDateInputField,
  type CommonDateInputFieldProps,
} from '../../../../common-ui/form-fields/CommonDateInputField';
import { getFieldProps } from '../../../../common-ui/form-fields/getFieldProps';
import type { UpdateIntermodalBookingFormModelDateKeys } from '../../../../services/intermodal/updateIntermodalReducer';
import { useUpdateIntermodalField } from '../../hooks/useUpdateIntermodalField';

interface UpdateIntermodalDateInputFieldProps
  extends Omit<CommonDateInputFieldProps, 'onValueChange' | 'trackerAction' | 'value'> {
  name: UpdateIntermodalBookingFormModelDateKeys;
  trackerCategory: TrackerCategory;
}

export const UpdateIntermodalDateInputField: FC<UpdateIntermodalDateInputFieldProps> = ({
  name,
  ...props
}) => {
  const fieldProps = useUpdateIntermodalField(name);

  return (
    <CommonDateInputField
      {...props}
      {...getFieldProps(props, fieldProps)}
      changed={fieldProps.initialValue !== fieldProps.editedValue}
    />
  );
};
